import { plural, msg, Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

/**
 * Conferma logout mobile quando ci sono incidenti offline non ancora esportati.
 */
export default function MobileLogoutConfirmDialog({
  open,
  count,
  onCancel,
  onConfirm,
  onExport,
  showExport,
}) {
  const { _ } = useLingui()
  const safeCount = Number.isFinite(count) && count > 0 ? count : 0

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="mobile-logout-confirm-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="mobile-logout-confirm-title">
        <Trans>Logout</Trans>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {_(plural(safeCount, {
            one: 'Logging out will delete # offline crash report not yet exported. Continue?',
            other:
              'Logging out will delete # offline crash reports not yet exported. Continue?',
          }))}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ flexWrap: 'wrap', gap: 1, px: 2, pb: 2 }}>
        <Button variant="outlined" onClick={onCancel}>
          <Trans>Cancel</Trans>
        </Button>
        {showExport ? (
          <Button variant="contained" onClick={() => void onExport()}>
            <Trans>Export</Trans>
          </Button>
        ) : null}
        <Button variant="contained" color="error" onClick={() => void onConfirm()}>
          {_(msg`Continue`)}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
